import { put, call, delay } from 'redux-saga/effects';
import moment from 'moment';
import { Types } from './actions';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';
import ReinforcementDataRepository from '../../../../data/repositories/ReinforcementDataRepository';
import config from '../../../../core/config/config';
import { getSortedEvents } from '../../../../presentation/modules/events/components/body/EventUtils';
import constants from '../../../../core/constants';
import DateHelpers from '../../../../core/helpers/DateHelper';

export function formatReinforcements(reinforcementsList: any[]) {
  return reinforcementsList.map((f: any) => {
    const date = new Date(f.date + constants.MIL_PERU);
    const startDate = f.date;
    const isToday = DateHelpers.isSameDay(date.getTime(), new Date().getTime());
    const today = moment(new Date()).format('DD/MM/YYYY');
    const customIsToday =
      moment(new Date(f.date + constants.MIL_PERU)).format('DD/MM/YYYY') ===
      today;
    return {
      ...f,
      isToday,
      startDate,
      customIsToday
    };
  });
}

export default function* execute(action: any): any {
  try {
    const { courseId, subscriptions } = action;
    yield put({ type: Types.GET_REINFORCEMENTS_BY_COURSE_REQUEST });
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementDataRepository();
    const reinforcementResponse = yield call(
      reinforcementRepository.getReinforcementsByCourse,
      courseId
    );
    if (!reinforcementResponse) {
      yield put({
        type: Types.GET_REINFORCEMENTS_BY_COURSE_FAILURE,
        error: true
      });
      return;
    }
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1500);
    const { reinforcements, featureds, eventsWaitingList } =
      reinforcementResponse;

    const newFeatureds = getSortedEvents(
      formatReinforcements([...reinforcements, ...featureds]),
      true
    ).filter((f: any) => !f.isSubscribed);
    const newSubscriptions = getSortedEvents(
      formatReinforcements(reinforcements),
      true
    );
    const newEventsWaitingList = getSortedEvents(
      formatReinforcements(eventsWaitingList),
      true
    );
    yield put({
      type: Types.GET_REINFORCEMENTS_BY_COURSE_SUCCESS,
      data: {
        reinforcements: newSubscriptions,
        featureds: newFeatureds,
        subscriptions:
          courseId === '' ? newSubscriptions.length : subscriptions,
        eventsWaitingList: newEventsWaitingList
      }
    });
  } catch (error) {
    yield put({
      type: Types.GET_REINFORCEMENTS_BY_COURSE_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos de los reforzamientos.'
    });
  }
}
